export const generateYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const prevYear = currentYear - 1;

  return [
    {
      value: currentYear.toString(),
      label: currentYear.toString(),
      isCurrent: true,
    },
    {
      value: prevYear.toString(),
      label: prevYear.toString(),
      isCurrent: false,
    },
  ];
};

/**
 * Safely converts a date string to ISO format.
 * Returns "" if the input is invalid.
 *
 * @param dateInput - A string or Date object to convert
 * @param trimMilliseconds - Whether to remove ".000Z" from the output
 */
export function safeToISOString(
  dateInput: string | Date | undefined | null,
  trimMilliseconds: boolean = true,
): string {
  if (!dateInput) return "";

  const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;

  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return "";
  }

  const iso = date.toISOString();
  return trimMilliseconds ? iso.replace(".000Z", "") : iso;
}
